import { CKEditorFormComponent } from '@/formbuilder/CKEditorFormComponent';
import type { StyleXStyles } from '@stylexjs/stylex';
import type { CKEditorFormComponentProps } from '@/formbuilder/CKEditorFormComponent';
import type { DisplayOnlyFormElementWrapperIF } from '@/formbuilder/formBuilder.constants';

/**
 * Returns a display-only form-builder `FormElement` as a workaround to prevent an import-cycle between form-builder and
 * the CKEditor. We use the `DisplayOnlyFormElementWrapper` component to slide the editor in where it is used (e.g. Add
 * Impact Report Modal) instead of in the global form-builder element registry.
 */
export const ckEditorFormElement = (
  props: Omit<
    CKEditorFormComponentProps,
    | 'component'
    | 'includeIf'
    | 'key'
    | 'displayNumber'
    | 'number'
    | 'defaultProvided'
    | 'formBlockXstyle'
    | 'formBlockClassNames'
  >,
  slotXstyle?: StyleXStyles,
): DisplayOnlyFormElementWrapperIF => ({
  component: 'DisplayOnlyFormElementWrapper',
  name: props.name,
  value: props.value,
  xstyle: slotXstyle,
  children: <CKEditorFormComponent component="CKEditorFormComponent" {...props} />,
});
